module.exports = __webpack_public_path__ + "static/media/24-7-road-emergency-service.b0add5e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/24-7-road-emergency-service.svg
// module id = 2541
// module chunks = 2